import { Link } from 'react-router-dom';
import Swipesign from '@/assets/logo/Swipesign.svg?react';
import Languages from '@/components/Header/Languages';
import styles from './MobileTopbar.module.scss';

const MobileTopbar = () => (
  <header className={styles.topbar}>
    <Link to="/dashboard" className={styles.home} aria-label="Swipesign">
      <Swipesign className={styles.logo} />
    </Link>
    <Languages popoverId="mobile-language-list" />
  </header>
);

export default MobileTopbar;
